import { FC, useMemo } from 'react'

import SafetyCaseHazardMitigationFormFields from './safety-case-hazard-mitigation-form-fields'

import { ISafetyCaseHazardMitigationFormProps } from './safety-case-hazard-mitigation-form-types'

const SafetyCaseHazardMitigationForm: FC<ISafetyCaseHazardMitigationFormProps> = props => {
  const { formName, handleSubmit, submitting, disabled } = props

  const isDisabled = useMemo(() => submitting || disabled, [submitting, disabled])

  return (
    <form onSubmit={handleSubmit} id={formName}>
      <SafetyCaseHazardMitigationFormFields disabled={isDisabled} />
    </form>
  )
}

export default SafetyCaseHazardMitigationForm
